import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Situatie from "@/components/site/Situatie";
import Planning from "@/components/site/Planning";
import UpdatesTeaser from "@/components/site/UpdatesTeaser";
import Ideeen from "@/components/site/Ideeen";
import Meedoen from "@/components/site/Meedoen";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Situatie />
        <Planning />
        <UpdatesTeaser />
        <Ideeen />
        <Meedoen />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
